<template>
  <router-view />
</template>

<script>

export default {
  name: 'Customers',
};
</script>
